import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { User } from './user.model';
import { environment } from '../../environments/environment';

@Injectable()
export class UserService {
  readonly rootUrl = environment.api;
  constructor(private http: HttpClient) { }

  registerUser(user: User) {
    const body: User = {
      UserName: user.UserName,
      Password: user.Password,
      Email: user.Email,
      FirstName: user.FirstName,
      LastName: user.LastName
    }
    var reqHeader = new HttpHeaders({'No-Auth':'True'});
    // return this.http.post(this.rootUrl + '/api/User/Register', body,{headers : reqHeader});
       return this.http.post(this.rootUrl + '/security/login', body,{headers : reqHeader});  }

   userAuthentication(userName, password) {
     var data = "username=" + "Admin" + "&password=" + "Admin@22" + "&grant_type=password";
     var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
     return this.http.post(this.rootUrl + '/Security/Login', data);
   }

  getUserClaims(){
   return  this.http.get(this.rootUrl+'/security/GetUserClaims');
  }

}
